<template>
  <div></div>
</template>

<script>
export default {
  name: 'base-footer',
};
</script>



// WEBPACK FOOTER //
// src/components/Base/Footer.vue